/**
 * Serializa operações de preferências por usuário no processo atual. A cadeia sobrevive à
 * limpeza dos stores: uma gravação em voo não pode disputar o JSON com um novo login da mesma
 * conta. Leituras também aguardam a cadeia para não restaurar o estado anterior à gravação.
 * Contas diferentes seguem independentes. Outras abas exigem atualização atômica no servidor.
 */
const pendingByUser = new Map<string, Promise<void>>()

export function runSerializedUserSettingsOperation<T>(
  userId: string,
  operation: () => Promise<T>,
): Promise<T> {
  const result = (pendingByUser.get(userId) ?? Promise.resolve()).then(operation)
  const settled = result.then(() => {}, () => {})
  pendingByUser.set(userId, settled)
  void settled.then(() => {
    if (pendingByUser.get(userId) === settled) pendingByUser.delete(userId)
  })
  return result
}
